import { useParams as useRouterParams } from 'react-router';

export function useParams<TResult extends Record<string, unknown>>(parser: (data: unknown) => TResult) {
  const params = useRouterParams();
  return parser(params);
}
